export default {
  AppTour: 'AppTour',
  AccountCreated: 'AccountCreated',
  AccountAssociated: 'AccountAssociated',
  RewardTour: 'RewardTour',
};
